// document.addEventListener("DOMContentLoaded", function () {
//     function initSlider(sliderContainerId, minThumbId, maxThumbId, minValueId, maxValueId, minInputId, maxInputId) {
//         const sliderContainer = document.getElementById(sliderContainerId);
//         const minThumb = document.getElementById(minThumbId);
//         const maxThumb = document.getElementById(maxThumbId);
//         const minValue = document.getElementById(minValueId);
//         const maxValue = document.getElementById(maxValueId);
//         const minInput = document.getElementById(minInputId);
//         const maxInput = document.getElementById(maxInputId);
//         const maxPriceLimit = parseInt(maxValue.textContent.replace(/,/g, ""), 10);

//         function formatPrice(value) {
//             return new Intl.NumberFormat("en-US", {
//                 minimumFractionDigits: 2,
//                 maximumFractionDigits: 2,
//             }).format(value);
//         }

//         function updateURL(min, max) {
//             const url = new URL(window.location);
//             url.searchParams.set("min_price", min);
//             url.searchParams.set("max_price", max);
//             history.pushState({}, "", url);
//         }

//         function moveThumb(thumb, clientX, isMin) {
//             const rect = sliderContainer.getBoundingClientRect();
//             let percent = ((clientX - rect.left) / rect.width) * 100;
//             percent = Math.max(0, Math.min(100, percent));

//             if (isMin) {
//                 const maxPercent = parseFloat(maxThumb.style.left);
//                 if (percent > maxPercent - 2) percent = maxPercent - 2;
//                 minThumb.style.left = percent + "%";
//                 const minPrice = formatPrice((percent / 100) * maxPriceLimit);
//                 minValue.textContent = minPrice;
//                 minInput.value = minPrice;
//             } else {
//                 const minPercent = parseFloat(minThumb.style.left);
//                 if (percent < minPercent + 2) percent = minPercent + 2;
//                 maxThumb.style.left = percent + "%";
//                 const maxPrice = formatPrice((percent / 100) * maxPriceLimit);
//                 maxValue.textContent = maxPrice;
//                 maxInput.value = maxPrice;
//             }

//             minInput.dispatchEvent(new Event("input", { bubbles: true }));
//             maxInput.dispatchEvent(new Event("input", { bubbles: true }));

//             updateURL(minInput.value, maxInput.value);
//         }

//         function enableDrag(thumb, isMin) {
//             function onMove(event) {
//                 const clientX = event.touches ? event.touches[0].clientX : event.clientX;
//                 moveThumb(thumb, clientX, isMin);
//             }

//             function onEnd() {
//                 document.removeEventListener("mousemove", onMove);
//                 document.removeEventListener("mouseup", onEnd);
//                 document.removeEventListener("touchmove", onMove);
//                 document.removeEventListener("touchend", onEnd);
//             }

//             document.addEventListener("mousemove", onMove);
//             document.addEventListener("mouseup", onEnd);
//             document.addEventListener("touchmove", onMove);
//             document.addEventListener("touchend", onEnd);
//         }

//         minThumb.addEventListener("mousedown", () => enableDrag(minThumb, true));
//         maxThumb.addEventListener("mousedown", () => enableDrag(maxThumb, false));
//         minThumb.addEventListener("touchstart", () => enableDrag(minThumb, true));
//         maxThumb.addEventListener("touchstart", () => enableDrag(maxThumb, false));

//         // Restore values from URL if present
//         const urlParams = new URLSearchParams(window.location.search);
//         const minPriceFromURL = urlParams.get("min_price");
//         const maxPriceFromURL = urlParams.get("max_price");

//         if (minPriceFromURL && maxPriceFromURL) {
//             const minPercent = (parseFloat(minPriceFromURL) / maxPriceLimit) * 100;
//             const maxPercent = (parseFloat(maxPriceFromURL) / maxPriceLimit) * 100;

//             minThumb.style.left = Math.max(0, Math.min(100, minPercent)) + "%";
//             maxThumb.style.left = Math.max(0, Math.min(100, maxPercent)) + "%";

//             minValue.textContent = formatPrice(minPriceFromURL);
//             maxValue.textContent = formatPrice(maxPriceFromURL);

//             minInput.value = minPriceFromURL;
//             maxInput.value = maxPriceFromURL;
//         }
//     }

//     // Initialize sliders for mobile and desktop
//     initSlider("FacetsWrapperMobile", "minThumbM", "maxThumbM", "minValueM", "maxValueM", "Mobile-Filter-Price-GTE", "Mobile-Filter-Price-LTE");
//     initSlider("FacetsWrapperDesktop", "minThumb", "maxThumb", "minValue", "maxValue", "Filter-Price-GTE", "Filter-Price-LTE");
// });



document.addEventListener("scroll", function () {
    let gfActions = document.querySelector(".facets-vertical");

    if (gfActions) {
        let elementTop = gfActions.getBoundingClientRect().top;

        if (elementTop <= 150) {
            gfActions.classList.add("scrolled");
        } else {
            gfActions.classList.remove("scrolled");
        }
    }
});

function addClassToFooter() {
    let footer = document.querySelector("footer");
    let path = window.location.pathname;

    if (footer) {
        if (path.includes("/collections/")) {
            footer.classList.add("footer-hide-collection");
        } 
        if (path.includes("/products/")) {
            footer.classList.add("footer-hide-collection");
        }
    }
}

document.addEventListener("DOMContentLoaded", function () {
    setTimeout(addClassToFooter, 2000); // 2-second delay
});


document.addEventListener('DOMContentLoaded', function() {
var intervalId = setInterval(function() {
if (window.location.href === "https://0cm.com/collections/sale") {
var element = document.querySelector("span[data-sort='title-ascending']");
if (element) {
element.click();
clearInterval(intervalId); 
}
}
}, 500); 

// Select the back-to-top button
const backToTopButton = document.querySelector('.back-to-top');

// Ensure the button exists before proceeding
if (backToTopButton) {
backToTopButton.addEventListener('click', function (e) {
e.preventDefault();
window.scrollTo({
top: 0,
behavior: 'smooth'
});
});
}
});

const buttons = document.querySelectorAll('.show-more-btn');

buttons.forEach(button => {
button.addEventListener('click', function() {
const container = this.closest('.card-body__colors');

if (container) {
if (!container.classList.contains('collapsed')) {
container.classList.add('collapsed');
} else {
container.classList.remove('collapsed');
}
}
});
});

 window.addEventListener('globoFilterRenderCompleted', function () {
    const buttons = document.querySelectorAll('.show-more-btn');

    buttons.forEach(button => {
    button.addEventListener('click', function() {
    const container = this.closest('.card-body__colors');
    
    if (container) {
    if (!container.classList.contains('collapsed')) {
    container.classList.add('collapsed');
    } else {
    container.classList.remove('collapsed');
    }
    }
    });
    });
  });
function openSizeChart() {
document.querySelector('.size-chart-modal').classList.add('active');
const productTitle = document.querySelector('.product__title > h1').textContent;
const mobileHeader = document.querySelector('#size-guide h2');
const desktopTitle = document.querySelector('.size-chart-title');
mobileHeader.textContent = productTitle;
desktopTitle.textContent = productTitle;

const unitSwitches = document.querySelectorAll('.unit-switch');

unitSwitches.forEach(function (switchElement) {
switchElement.addEventListener('click', function () {
const unit = this.getAttribute('data-unit'); // 'cm' or 'inch'
if (!this.classList.contains('active')) {
toggleUnits(unit);
}
});
});

function toggleUnits(unit) {
const activeUnitSwitch = document.querySelector('.unit-switch.active');
if (activeUnitSwitch) {
activeUnitSwitch.classList.remove('active');
}
const currentUnitSwitch = document.querySelector(`.unit-switch[data-unit="${unit}"]`);
currentUnitSwitch.classList.add('active');

// Retrieve all rows in the table body
const rows = document.querySelectorAll('.size-table .body-row');
rows.forEach(row => {
// Indexes of Length, Bust, Sleeve, Waist in the table columns
const lengthIndex = 3;
const bustIndex = 4;
const sleeveIndex = 5;
const waistIndex = 6;

// Update each relevant cell
[lengthIndex, bustIndex, sleeveIndex, waistIndex].forEach(index => {
const cell = row.children[index];
if (cell) {
let value = parseFloat(cell.textContent.trim());
if (unit === 'inch') {
// Convert cm to inches, assuming the initial values are in cm, and round to the nearest whole number
value = Math.round(value / 2.54);
} else {
// Convert inches back to cm, assuming the initial values are in inches, and round to the nearest whole number
value = Math.round(value * 2.54);
}
cell.textContent = value;
}
});
});
}
}

function closeActiveModal() {
document.querySelector('.modal.active').classList.remove('active');
}


document.addEventListener("rivo-js-loaded", function () {
RivoJS.getCustomerVipTier().then(function (resp) {
if (!resp) return;
const tier = resp.tier.name
const tierWrapper = document.querySelector('.header__tier-status');
const tierWrapperMoblie = document.querySelector('.header__tier-status-mobile');
tierWrapperMoblie.textContent = tier;
tierWrapper.textContent = tier;
});

if (document.querySelector('.rivo-account')) {
RivoJS.getCustomerVipTier().then(function (resp) {
console.log(resp)
document.querySelector('.rivo-tier span ').textContent = `${resp.tier.name}`;
});
RivoJS.getCustomerDetails().then(function (resp) {
console.log(resp)
document.querySelector('.rivo-points h3 span').textContent = resp.points_tally;
document.querySelector('span[data-expiration-date]').textContent = resp.points_expiry;
});
}
if (!window.location.href.includes('loyalty-program-page')) return false;

RivoJS.getCustomerDetails().then(function (resp) {
console.log(resp)
document.querySelector('.rivo-account [data-points]').innerHTML = `${resp.points_tally}`;
document.querySelector('.rivo-account [data-expiration-date]').innerHTML = ` ${resp.points_expiry}`;
});

RivoJS.getCustomerVipTier().then(function (resp) {
console.log(resp)
document.querySelector('.rivo-account [data-tier]').innerHTML = `${resp.tier.name}`;
});

RivoJS.getCustomerVipTier().then(function (resp) {
var pointsNeeded = resp.next_tier.to_spend_or_earn;
var tierName = resp.next_tier.name;
var vipInfoP = document.getElementById('vip-unlock');
if (vipInfoP) {
vipInfoP.innerHTML = "Earn " + pointsNeeded + " more points to reach " + tierName;
}
});

RivoJS.getShopRewards().then(function (resp) {
if (!document.querySelectorAll('.redeem-rewards')) return false;
document.querySelectorAll('.redeem-rewards').forEach(item => {
console.log(item)
resp.forEach(reward => {
item.innerHTML += `
<div class="reward-item">
<div class="reward-top">
<svg width="23" height="16" viewBox="0 0 23 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1.5 13V3C1.5 2.46957 1.71071 1.96086 2.08579 1.58579C2.46086 1.21071 2.96957 1 3.5 1H19.5C20.0304 1 20.5391 1.21071 20.9142 1.58579C21.2893 1.96086 21.5 2.46957 21.5 3V13C21.5 13.5304 21.2893 14.0391 20.9142 14.4142C20.5391 14.7893 20.0304 15 19.5 15H3.5C2.96957 15 2.46086 14.7893 2.08579 14.4142C1.71071 14.0391 1.5 13.5304 1.5 13Z" stroke="#0E0D0D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M18 8.01L18.01 7.999M5 8.01L5.01 7.999M11.5 11C10.7044 11 9.94129 10.6839 9.37868 10.1213C8.81607 9.55871 8.5 8.79565 8.5 8C8.5 7.20435 8.81607 6.44129 9.37868 5.87868C9.94129 5.31607 10.7044 5 11.5 5C12.2956 5 13.0587 5.31607 13.6213 5.87868C14.1839 6.44129 14.5 7.20435 14.5 8C14.5 8.79565 14.1839 9.55871 13.6213 10.1213C13.0587 10.6839 12.2956 11 11.5 11Z" stroke="#0E0D0D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
<span class="font-lg fw-medium">
${reward.name}
</span>
</div>
<span class="font-lg fw-regular" style="color: var(--main-800); display: flex; margin-top: 4px">${reward.points_amount} Points</span>

<button data-id="${reward.id}" class="button button-icon">
<span>Redeem Reward</span>
</button>
</div>
`;

})
const btns = document.querySelectorAll('.reward-item .button');
btns.forEach(btn => {
btn.addEventListener('click', function (e) {
e.stopPropagation();
RivoJS.redeemReward(btn.getAttribute('data-id')).then(function (resp) {
const item = document.querySelector('.reward-item')
if (resp.success) {
item.innerHTML = `<p class="reward-item__code">${resp.points_purchase.code}</p>`
} else {
item.innerHTML = `<p class="reward-item__code">${resp.errors}</p>`
}
});
})
})
})

});
});


document.addEventListener('DOMContentLoaded', () => {
const barBtn = document.querySelector('.icon-close-bar');
const bar = document.querySelector('.announcement-bar-section');

if (barBtn && bar) {  // Check if both elements exist
barBtn.addEventListener('click', (e) => {
if (!bar.classList.contains('hide')) {
bar.classList.add('hide');
}
});
}
});


document.addEventListener('DOMContentLoaded', function () {
var input = document.getElementById('Search-In-Modal');
var menu = document.querySelector('.header__inline-menu');

if (input && menu) {
input.addEventListener('focus', function () {
menu.classList.add('hide');
});

input.addEventListener('blur', function () {
menu.classList.remove('hide');
});
}

const sizeOptionsContainers = document.querySelectorAll('.product-form__input');

sizeOptionsContainers.forEach(function (container) {
const options = container.querySelectorAll('input[type="radio"]');
options.forEach(function (option) {
option.addEventListener('click', function () {
const selectedSize = this.value;
const displaySpan = container.querySelector('.variant-selects__value span');
if (displaySpan) {
displaySpan.textContent = selectedSize;
}
});
});
});

function hideEmptyReviewSection() {
const reviewWidget = document.querySelector('.jdgm-rev-widg');
if (reviewWidget && reviewWidget.getAttribute('data-number-of-reviews') == 0) {
reviewWidget.closest('.shopify-section').style.display = 'none';
}
}

function observeElement(selector, callback) {
const targetNode = document.body;

const observerOptions = {
childList: true,
subtree: true
};

const observer = new MutationObserver((mutationsList, observer) => {
for (const mutation of mutationsList) {
if (mutation.type === 'childList') {
if (document.querySelector(selector)) {
callback();
observer.disconnect();
break;
}
}
}
});

observer.observe(targetNode, observerOptions);
}

if (document.querySelector('#id-product')) {
observeElement('.jdgm-rev-widg', hideEmptyReviewSection);
}
});



document.addEventListener('DOMContentLoaded', function () {
// const gridItems = document.querySelectorAll('.grid__item .product-card');
//
// // Check if there are any grid items
// if (gridItems.length > 0) {
// 	let maxHeight = 0;
//
// 	// Find the maximum height
// 	gridItems.forEach(item => {
// 		const itemHeight = item.offsetHeight;
// 		if (itemHeight > maxHeight) {
// 			maxHeight = itemHeight;
// 		}
// 	});
//
// 	// Set all items to the maximum height
// 	gridItems.forEach(item => {
// 		item.style.height = maxHeight + 'px';
// 	});
// } else {
// 	console.warn('No elements with the class "grid__item" found.');
// }

// Найти все кнопки увеличения в каждом слайде
const zoomButtons = document.querySelectorAll('.swiper-slide .product-zoom');
const closeButton = document.querySelector('.zoom-popup .icon-close');
const popup = document.querySelector('.zoom-popup');
const popupWrapper = document.querySelector('.zoom-popup-wrapper');

if (!zoomButtons.length || !closeButton || !popup || !popupWrapper) {
// console.error('Some elements are missing, cannot attach event listeners.');
return; // Если какие-то элементы отсутствуют, прекратить выполнение
}

zoomButtons.forEach(button => {
button.addEventListener('click', function () {
// Найти изображение в том же слайде, что и кнопка
const imageElement = this.closest('.swiper-slide').querySelector('img');
if (!imageElement) {
console.error('No image found in the slide.');
return; // Если изображение не найдено, прекратить выполнение
}
const imageUrl = imageElement.src;

// Создать элемент <img>, если его еще нет
let img = popupWrapper.querySelector('img');
if (!img) {
img = document.createElement('img');
popupWrapper.appendChild(img);
}
img.src = imageUrl;

// Показать попап
popup.classList.add('active');
});
});

// Функция для закрытия попапа и удаления изображения
closeButton.addEventListener('click', function () {
// Удалить изображение из попапа
const img = popupWrapper.querySelector('img');
if (img) {
popupWrapper.removeChild(img);
}
// Скрыть попап
popup.classList.remove('active');
});
});


// Функция для добавления параграфа
function addFooterRights() {
// Создаем параграф
const paragraph = document.createElement('p');
paragraph.className = 'footer__rights';
const currentYear = new Date().getFullYear(); // Получаем текущий год
paragraph.textContent = `© ${currentYear}, 0cm. All rights reserved.`;

// Находим контейнер, куда добавляем параграф
const contentContainer = document.querySelector('.locale-selectors__container');
if (contentContainer) {
contentContainer.parentElement.style.backgroundColor = '#F5F2F0';
contentContainer.appendChild(paragraph); // Добавляем параграф в конец блока контент
}
}

// Создаем экземпляр MutationObserver
const observer = new MutationObserver(function (mutations) {
for (const mutation of mutations) {
if (mutation.type === 'childList') {
mutation.addedNodes.forEach(node => {
// Проверяем, является ли добавленный узел элементом с нужным классом
if (node.nodeType === Node.ELEMENT_NODE && node.classList.contains('locale-selectors__container')) {
addFooterRights(); // Вызываем функцию добавления параграфа
}
});
}
}
});


const config = {
childList: true,
subtree: true
};

// Начинаем наблюдение за изменениями в body документа
observer.observe(document.body, config);


document.addEventListener('DOMContentLoaded', function() {
const menuIcon = document.querySelector('.menu-drawer-container .header__icon.header__icon--menu');
if (menuIcon) {
menuIcon.addEventListener('click', (e) => {
document.querySelector('html').classList.toggle('overflow');
});
}
});



const cmToInchRatio = 0.393701;

document.getElementById('unit-cm').addEventListener('click', function () {
setUnits('cm');
});
document.getElementById('unit-inch').addEventListener('click', function () {
setUnits('inch');
});

function setUnits(unit) {
document.querySelectorAll('.unit-button').forEach(button => {
button.classList.remove('active');
});
document.getElementById(`unit-${unit}`).classList.add('active');

document.querySelectorAll('td.length, td.bust, td.sleeve, td.waist').forEach(cell => {
const cmValue = cell.dataset.cmValue || cell.textContent;
cell.dataset.cmValue = cmValue; // Store the original cm value
cell.textContent = (unit === 'cm') ? cmValue : Math.round(cmValue * cmToInchRatio);
});
}

// Initialize with CM values
setUnits('cm');

var lgth=$('.accordian .product__accordion').length;
if(lgth>2){
$('.main-product-new-layout .left-box .product-video').addClass('showheight');
}
else{
$('.main-product-new-layout .left-box .product-video').removeClass('showheight');
}

document.addEventListener("DOMContentLoaded", function() {
// Get all tab links
var tabLinks = document.querySelectorAll(".sidetab-link");

// Get the current URL
var currentUrl = window.location.href;

// Add the active class to the tab that matches the current URL
tabLinks.forEach(function(link) {
if (link.href === currentUrl) {
link.classList.add("active");
}
});
});

$(document).ready(function() {
$('.sidebar-hamburger').click(function() {
$('.page-leftsidebar').slideToggle();
});
$(document).on('click','.custom-account-page .newaddress-btn',function(e) {
e.preventDefault();
$('.AddAddress-area').slideToggle();
$(this).toggleClass('openclose-address');
});
});
function appendCustomButton() {
// Select all elements that match the selector
var elements = document.querySelectorAll('.gf-left #gf-tree [data-filter-type="color"] ul');
var elementSizes = document.querySelectorAll('.gf-left #gf-tree [data-filter-type="size"] ul');
var elementsMatas = document.querySelectorAll('.gf-left #gf-tree [data-filter-type="Collection"] .collection-metafield-inner ul');
// Define the HTML code to append
//     var codeToAppendMata = `
//     <li class="custombutton">
// <a href="/collections/all"> <span class="gf-Checkbox"></span> 
//          <span class="gf-label">All</span></a>
//     </li>
//   `;
elementsMatas.forEach(function(elementsMata) {
// elementsMata.insertAdjacentHTML('beforeend', codeToAppendMata);
var firstLi = elementsMata.querySelector('li:first-child');

if (firstLi) {
// Replace the text content with "All"
var label = firstLi.querySelector('.gf-label');
if (label) {
label.textContent = "All";
} else {
// If the .gf-label element doesn't exist, just replace the entire text of the <li>
firstLi.textContent = "All";
}
}

});

}
function appendSelectedOption() {
setTimeout(function() {
// Select the checked list item
var checkedLi = document.querySelector('.collection-metafield-inner.gf-block-content ul li.checked');

// Check if the checkedLi element exists
if (checkedLi) {
// Get the text content of the nested gf-label span
var gfLabelSpan = checkedLi.querySelector('.gf-label');

if (gfLabelSpan) {
var checkedText = gfLabelSpan.innerText.trim(); // Trim whitespace for cleaner output

// Validate checkedText
if (checkedText) {
// Select the container where the item will be added
var selectedItemsContainer = document.querySelector('.gf-actions .globo-selected-items');

// Check if selectedItemsContainer exists
if (selectedItemsContainer) {
var selectedItem = `
<li class="selected-item gf-option-label">
<a href="/collections/all" class="gf-clear">
<span class="selected-item">
<strong><span class="gf-label">${checkedText}</span></strong>
</span>
<span class="gf-clear">
<svg viewBox="0 0 50 50">
<path fill="currentColor" d="M25.5 6C15 6 6.5 14.5 6.5 25C6.5 35.5 15 44 25.5 44C36 44 44.5 35.5 44.5 25C44.5 14.5 36 6 25.5 6ZM34.4 31.9L32.5 33.8L25.6 26.9L18.7 33.8L16.8 31.9L23.7 25L16.8 18.1L18.7 16.2L25.6 23.1L32.5 16.2L34.4 18.1L27.4 25L34.4 31.9Z"></path>
</svg>
</span>
</a>
</li>
`;
selectedItemsContainer.insertAdjacentHTML('beforeend', selectedItem);

// Update the text of the active-txt element
var activeTxtElement = document.querySelector('.collection .gf-option-block[data-filter-type="Collection"] .active-txt');

if (activeTxtElement) {
activeTxtElement.textContent = checkedText; 
} else {
console.error('Active text element not found.');
}
} else {
console.error('Selected items container not found.');
}
} else {
console.error('Checked text is empty or invalid.');
}
} else {
console.error('gf-label span not found within checked list item.');
}
}
}, 2000); // Delay of 2000 milliseconds
}

function appendSelectedTrending() {
// Find the element with the class 'collection-metafield'
var selectedTrending = document.querySelector('.collection-metafield'); 

// Check if selectedTrending exists
if (selectedTrending) {
// Get the attribute 'coldata' from the selected element
var selectedAttribute = selectedTrending.getAttribute('coldata');

// Timeout function to alert the selected attribute
setTimeout(() => {
if (selectedAttribute === 'trending') {
$('.gf-filter-selection').after('<div class="custom-trending"><div class="sort-by"><label class="sort-by-toggle"><span>Trending Selling</span></label></div></div>');
$('.gf-filter-selection').hide();
} else {
$('.custom-trending').remove();
$('.gf-filter-selection').show();
}
}, 2100);
}
}

// Adding the selectedItem HTML and setting up the event listener once
document.addEventListener("DOMContentLoaded", function() {
appendSelectedOption();
appendSelectedTrending();
// Document ready function


});

jQuery(document).ready(function($){
var categorytimer = setInterval(function(){
var category = $('.gf-filter-contents .gf-option-block[data-filter-type="Collection"]').hasClass('gf-option-block');
if (category == true) {
$('.gf-filter-contents .gf-option-block[data-filter-type="Collection"]').removeClass('is-collapsed');
$('.gf-filter-contents .gf-option-block[data-filter-type="Collection"] .gf-block-content').remove();
var metafield_collection = $('.collection-metafield').html();
$('.gf-filter-contents .gf-option-block[data-filter-type="Collection"]').append(metafield_collection);

var url_collection = window.location.href;
var url_collection_split = url_collection.split('collections/');
var url_collection_split_last = url_collection_split[1];
$('.collection-metafield-inner li').removeClass('checked');
$('.collection-metafield-inner a[href="' + url_collection_split_last + '"]').closest('li').addClass('checked');

$('.gf-option-block').each(function(){
$(this).find('.gf-block-content').before("<span class='active-txt'>All</span>");
});

clearInterval(categorytimer);
}
appendCustomButton();

}, 1);
});








document.addEventListener('DOMContentLoaded', () => {
const referrerURL = document.referrer;
if (referrerURL) {
// Extract the part after 'collections/' from the referrer URL
const brandcrum = referrerURL;
const brandcrum_split = brandcrum.split('collections/');
if (brandcrum_split.length > 1) {
let brandcrum_split_last = brandcrum_split[1].split('/')[0]; // Assuming you want the first part after 'collections/'
brandcrum_split_last = brandcrum_split_last.replace(/(women|men|kids)/gi, '').trim();

// Replace dashes with spaces
brandcrum_split_last = brandcrum_split_last.replace(/-/g, ' ');

// Capitalize each word
brandcrum_split_last = brandcrum_split_last.split(' ')
.map(word => word.charAt(0).toUpperCase() + word.slice(1))
.join(' ');

// Remove text after '?' if it exists
if (brandcrum_split_last.includes('?')) {
brandcrum_split_last = brandcrum_split_last.split('?')[0].trim();
}

// Update the breadcrumb text
const breadcrumbElement = document.querySelector('.main-product .breadcrumbs li.breadcrumbs__item:nth-child(2) a');
if (breadcrumbElement) {
breadcrumbElement.textContent = brandcrum_split_last;

// Append brandcrum_split_last to the current href as a query parameter
let currentHref = breadcrumbElement.getAttribute('href');
let updatedHref = brandcrum;
breadcrumbElement.setAttribute('href', updatedHref);
}
}
}
});


document.addEventListener('DOMContentLoaded', function() {
setTimeout(function() {
// Get the href attribute of the breadcrumb link and modify it
var breadcrumbLinkElement = document.querySelector('.breadcrumbs__item.two a.breadcrumbs__link');

if (breadcrumbLinkElement) {
var breadcrumbsLink = breadcrumbLinkElement.getAttribute('href');
var partToRemove = 'https://0cm.com/';
var modifiedLink = breadcrumbsLink.replace(partToRemove, '');

// Get all mega menu links
var megaMenuLinks = document.querySelectorAll('.header__inline-menu .mega-menu__list');

megaMenuLinks.forEach(function(element) {
var links = element.querySelectorAll('a');

links.forEach(function(link) {
var megaMenuLink = link.getAttribute('href');
var megafiedLink = megaMenuLink.replace(partToRemove, '');

if (megafiedLink === modifiedLink) {
// Get data attributes
var closestList = link.closest('.list-unstyled');
if (closestList) {
var dataName = closestList.getAttribute('data-link');
var dataLink = closestList.getAttribute('data-url');

function addBreadcrumb(dataLink, dataName) {
// Check if dataLink and dataName are valid
if (dataLink && dataName) {
// Create and insert the new breadcrumb item
const newItemHTML = `
<a class="breadcrumbs__link" href="${dataLink}">${dataName}</a>
`;
const breadcrumbsList = document.querySelector('.breadcrumbs__item.three');
if (breadcrumbsList) {
breadcrumbsList.classList.remove('hidden');
breadcrumbsList.insertAdjacentHTML('beforeend', newItemHTML);
}
} else {
console.error('Data attributes are missing or invalid.');
}
}

// Add the breadcrumb item
addBreadcrumb(dataLink, dataName);
} else {
console.error('No closest .list-unstyled element found.');
}
}
});
});
}
}, 200); // Delay of 200 milliseconds


function startChecking() {
var textTag = '';
var textGender = '';
var checkInterval = setInterval(function() {
var dataFilterTypeTags = document.querySelectorAll('.gf-option-block[data-filter-id="553698"] .gf-block-content ul button');
var dataFilterTypeGenders = document.querySelectorAll('.gf-option-block[data-filter-id="553722"] ul button');

if (dataFilterTypeTags.length > 0 && dataFilterTypeGenders.length > 0) {
dataFilterTypeTags.forEach(function(dataFilterTypeTag) {
dataFilterTypeTag.addEventListener('click', function() {
dataFilterTypeTag.classList.toggle('checked');
if (dataFilterTypeTag.classList.contains('checked')) {
textTag = dataFilterTypeTag.querySelector('.gf-label').textContent.toLowerCase();

if (textTag && textGender) {
var redirectUrl = `https://0cm.com/collections/${textGender}-${textTag}`;
// clearInterval(checkInterval);
window.location.href = redirectUrl;
}
}

});
});

// Add event listeners to gender buttons
dataFilterTypeGenders.forEach(function(dataFilterTypeGender) {
dataFilterTypeGender.addEventListener('click', function() {
dataFilterTypeGender.classList.toggle('checked');
if (dataFilterTypeGender.classList.contains('checked')) {
textGender = dataFilterTypeGender.querySelector('.gf-label').textContent.toLowerCase();

if (textTag && textGender) {
var redirectUrl = `https://0cm.com/collections/${textGender}-${textTag}`;
// clearInterval(checkInterval);
window.location.href = redirectUrl;
}
}

});
});
}
}, 100);
}
// Start checking when the DOM is loaded
startChecking();

// Function to scroll to the checked item within .gf-block-scroll containers
function scrollToChecked() {
setTimeout(function() {
const scrollContainers = document.querySelectorAll('.gf-block-scroll');
if (!scrollContainers.length) return;

scrollContainers.forEach(scrollContainer => {
const checkedItem = scrollContainer.querySelector('ul li button.checked');
if (checkedItem) {
const closestLi = checkedItem.closest('li');
if (closestLi) {
const offsetTop = closestLi.offsetTop;
scrollContainer.scrollTop = offsetTop;
}
}
});
}, 3500); 
}

scrollToChecked();
});


// faq page code****************************

document.querySelectorAll('.faq-inner-loop .content').forEach(function(element) {
element.addEventListener('click', function() {
var faqInnerLoop = this.closest('.faq-inner-loop');
var contentFaq = faqInnerLoop.querySelector('.content-faq');
var hasActiveClass = contentFaq.classList.contains('active');

if (hasActiveClass) {
document.querySelectorAll('.faq-inner-loop .content-faq').forEach(function(el) {
el.classList.remove('active');
});
document.querySelectorAll('.faq-inner-loop').forEach(function(el) {
el.classList.remove('active');
});
} else {
document.querySelectorAll('.faq-inner-loop').forEach(function(el) {
el.classList.remove('active');
});
document.querySelectorAll('.faq-inner-loop .content-faq').forEach(function(el) {
el.classList.remove('active');
});

faqInnerLoop.classList.add('active');
contentFaq.classList.add('active');
}
});
});

// Brands page code
$(document).ready(function() {
// Initially hide the additional text
$('.collection-group').each(function(){
var lt=$(this).find('.brandGrid').length;
if(lt >= 8){
$(this).find('.read-more').show();
}
else{
$(this).find('.read-more').hide();
}
});


// Handle the click event for "Read More"
$('.read-more').click(function(e) {
e.preventDefault();

var $this = $(this);
var $moreText = $this.siblings('.collection-group').find('.brandGrid');

if ($this.text() === 'Show More') {
$this.closest('.collection-group').find('.brandGrid').addClass('active');
$this.text('Show Less');
} else {
$this.closest('.collection-group').find('.brandGrid').removeClass('active');
$this.text('Show More');

}
});


function initializeSlick() {
$('.brandGrid-wrapper').each(function(){
var $this = $(this);
var brandGridCount = $this.find('.brandGrid').length;

// Add a class if the number of .brandGrid elements is less than 2
if (brandGridCount < 2) {
$this.addClass('less-than-two');
} else {
$this.removeClass('less-than-two');
}

if ($(window).width() <= 768) { // Check if screen width is 768px or less (mobile)
if (brandGridCount > 1 && !$this.hasClass('slick-initialized')) {
$this.slick({
infinite: false, // Set to true if you want an infinite loop
slidesToShow: 2.5, // Show 2 slides at a time on mobile (default)
slidesToScroll: 1, // Scroll 1 slide at a time
dots: true, // Disable pagination dots
arrows: true, // Enable next/previous arrows
prevArrow: '<button type="button" class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0691/7436/2425/files/Navigation_3a47e55e-cae0-414c-8dad-b59850d56cea.png?v=1733726368" alt="Previous"></button>',
nextArrow: '<button type="button" class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0691/7436/2425/files/Navigation_1_bbffa7f6-4faa-4109-b26f-3cf1e028cb78.png?v=1733726368" alt="Next"></button>',
responsive: [
{
breakpoint: 480, // Screen width 480px or less
settings: {
slidesToShow: 2, // Show 1 slide at a time
}
}
]
});
}
} else {
if ($this.hasClass('slick-initialized')) {
$this.slick('unslick'); // Destroy slick if screen is resized above mobile width
}
}
});
}

initializeSlick(); // Initialize slick on page load

$(window).resize(function() {
initializeSlick(); // Re-check on window resize
});
});


$('.zeroopen').next().removeAttr('open');


$(window).on('scroll',function() {
  var scrolling_pos = $(window).scrollTop();
  var mobile_filter = $('.product-grid-container #gf-controls-container');
  var sticky_header = $('.header--scrolled').height();
  if(scrolling_pos > 200) {
  if (mobile_filter && sticky_header) {
        mobile_filter.addClass('sticky-filter').css('top', sticky_header + 'px');;
    }
  }
  else {
    mobile_filter.removeClass('sticky-filter');
  }
});

// custom Frequently bought together Section script
$(document).ready(function(){
    $('.cstm-fbt-my-main-pop').hide(function(){$('body').removeClass('cstm-fbt-popup-open');});
    $('.frequently-bought-btn').click(function (e) {
        e.preventDefault();
        
        var currency = $('.freq-bought-header').data('currency');
        var cleanCurrency = currency.replace(/\{\{.*?\}\}/g, '').trim();
    
        $(this).toggleClass('frequently-bought-btn-active');
        var title = $(this).data('fbt-title');
        var price = $(this).data('fbt-price');
        var image = $(this).data('fbt-image');
        var productVarId = $(this).data('fbt-var');
        var productId = $(this).data('fbt-id');
    
        var mainProductId = $('.frequently-bought-btn-main').data('fbt-id');
        var mainProductVarId = $('.frequently-bought-btn-main').data('fbt-var');
        var mainProductTitle = $('.frequently-bought-btn-main').data('fbt-title');
        var mainProductImage = $('.frequently-bought-btn-main').data('fbt-image');
        var mainProductPrice = $('.frequently-bought-btn-main').data('fbt-price');
        var checkMainPro = $('.my-fbt-pop-up .cstm-fbt-added-product-list').find('.cstm-fbt-product-content[data-id="' + mainProductId + '"]');
        if (checkMainPro.length > 0) {
            console.log('Main product FOUND');
        } else {
            const mainProductHtml = `
              <div class="cstm-fbt-product-content" data-id="${mainProductId}" data-variation="${mainProductVarId}">
                  <div class="product-image">
                      <img src="${mainProductImage}" alt="${mainProductTitle}">
                  </div>
                  <div class="product-details">
                      <span class="h4">${mainProductTitle}</span>
                      <p>${cleanCurrency} ${mainProductPrice}</p>
                  </div>
              </div>
            `;
            $('.my-fbt-pop-up .cstm-fbt-added-product-list').append(mainProductHtml);
        }
    
        if ($(this).hasClass('frequently-bought-btn-active')) {
            const productHtml = `
              <div class="cstm-fbt-product-content" data-id="${productId}"  data-variation="${productVarId}">
                  <div class="product-image">
                      <img src="${image}" alt="${title}">
                  </div>
                  <div class="product-details">
                      <span class="h4">${title}</span>
                    <p>${cleanCurrency} ${price}</p>
                  </div>
              </div>
            `;
            $('.my-fbt-pop-up .cstm-fbt-added-product-list').append(productHtml);
            $('.my-fbt-pop-up').show(function(){$('body').addClass('cstm-fbt-popup-open');});
        } else {
             $('.my-fbt-pop-up .cstm-fbt-added-product-list').find(`.cstm-fbt-product-content[data-id="${productId}"]`).remove();
        }
        var total = 0;
        $('.frequently-bought-btn-active').each(function () {
            var priceStr = $(this).data('fbt-price');
            if (priceStr) {
                var numericValue = parseFloat(priceStr.toString().replace(/,/g, ''));
                if (!isNaN(numericValue)) {
                    total += numericValue;
                }
            }
        });
        var total_with_currency = cleanCurrency+' '+total;
        $('.fbt-subtotal-amount').text(total_with_currency);
        $('.fbt-total-amount').text(total_with_currency);
    });
    
    $('.cstm-close-fbt-pop-up').click(function (e) {
        $('.cstm-fbt-my-main-pop').hide(function(){$('body').removeClass('cstm-fbt-popup-open');});
    });
    
    $('.cstm-add-all-in-cart-btn').click(function(e){
        e.preventDefault();
        const items = [];
        $('.cstm-fbt-product-content').each(function() {
            const variationId = $(this).data('variation');
            items.push({
                id: variationId,
                quantity: 1
            });
        });
        console.log(items);
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            dataType: 'json',
            contentType: 'application/json',
            data: JSON.stringify({
                items: items
            }),
             success: function(response) {
                console.log('All items added successfully:', response);
                window.location.reload();
            },
            error: function(error) {
                console.error('Error adding items to cart:', error);
            }
        });
    });
    
    $('.cstm-select-var').click(function (e) {
        var varid = $(this).data('varid');
        var change_var_id = $(this).closest('.cstm-frequently-bought-item').find('.frequently-bought-btn');
        change_var_id.attr('data-fbt-var', varid);
    })
});
// custom Frequently bought together Section script end


// FBT Sec
document.querySelector('.final-cross-fbt').addEventListener('click', function(){
    document.querySelector('.button-box-freq.active').click();
});

document.querySelectorAll('.freq-bought .radio-text').forEach(function(freq_item) {
    var freq_item_title = freq_item.innerText;
    console.log("freq_item_title", freq_item_title);
    if(freq_item_title == 'Default title'){
        freq_item.closest(".freq-bought").style.display = 'none';
    }
});